$(document).ready(function(){
  /*========================================
  TABS LABELS
  ========================================*/ 
  $('.tabs-labels--label').on('click', function(){
    $(this).parent().find('.tabs-labels--label').removeClass('tabs-labels--active');
    $(this).addClass('tabs-labels--active');
    var label = $(this).attr('data-tab');
    $('.tabs-contents--content').removeClass('tabs-contents--active');
    $(label).addClass('tabs-contents--active');
  });
  
  /*========================================
  DISTRIBUTORS ACCORDION
  ========================================*/ 
  $('.accordion-block').on('click', function(){
        $('.accordion-block').not(this).removeClass('accordion-block-active');
        $(this).toggleClass('accordion-block-active');  
  });
  
});
